export default "__VITE_ASSET__2ba9c8e0__"